module.exports = __webpack_public_path__ + "media/02_ASANBUDAPEST-Vibes02.602afac5.mp3";